import React from 'react';
import { Alert as BaseAlert } from '../forms/ModalForm';

export class Alert extends React.Component {
    static show(options = {}) {
        Alert.__singletonRef.__show(options);
    }

    static hide() {
        Alert.__singletonRef.__hide();
    }

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            body: null,
            title: '',
            keyboard: true,
            backdrop: true,
        };

        Alert.__singletonRef = this;
        this.__hide = this.__hide.bind(this);
        this.__show = this.__show.bind(this);
    }

    __show(options) {
        const { body, ...restOptions } = options;

        this.setState({
            show: true,
            body,
            title: '',
            keyboard: true,
            backdrop: true,
            ...restOptions || {},
        });
    }

    __hide() {
        this.setState({
            show: false,
            body: null,
            title: '',
            keyboard: true,
            backdrop: true,
        });
    }

    render() {
        const {
            show, title, keyboard, backdrop, body, size,
        } = this.state;

        if (!show) {
            return null;
        }

        return (
            <BaseAlert
                title={title}
                keyboard={keyboard}
                backdrop={backdrop}
                toggle={this.__hide}
                isOpen={show}
                {...(size && { size })}
            >
                {body}
            </BaseAlert>
        );
    }
}